import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from '@emotion/styled';
import borders from '../../../../../theme/borders';
import WYPIcon from '../../../../../atoms/icons/WYPIcon';
import PrimaryButton from '../../../../../atoms/buttons/PrimaryButton';
import { getBrowserDetails, isDarkMode } from '../../../../../utils/helpers';
import breakpoints from 'theme/material/breakpoints';

export const Container = styled('div')({
  height: getBrowserDetails().hImgCalibration,
  maxHeight: getBrowserDetails().hImgCalibration,
  textAlign: 'center',
});

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
export const MessageCard = styled('div')(() => {
  const theme = isDarkMode() ? 'dark' : 'light';

  return {
    borderRadius: 10,
    background: !isDarkMode() ? '' : 'backgrounds.dark.primaryCard',
    border: `1px solid ${borders[theme].primary}`,
    padding: '77px 48px',
    marginBottom: 23,
    textAlign: 'center',
    [breakpoints.down(375.05)]: {
      padding: '38px 48px',
    },
  };
});

export const DescriptionText = styled('p')({
  fontSize: 18,
  lineHeight: '23px',
});

const OneTapNoMoreOffersScreen: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <MessageCard>
        <WYPIcon customStyle={{ width: 100, height: 79 }} />
        <h3 style={{ fontSize: 18, marginTop: 31, marginBottom: 16, lineHeight: '23px' }}>
          You have no more <br />
          Offer Requests to review.
        </h3>
        <DescriptionText>
          You may be at the end of your offers, but {`we're`} not at the end of the fun! Check out Search and make some
          offers of your own!
        </DescriptionText>
      </MessageCard>
      <PrimaryButton
        size="regular"
        color="red"
        label="Go to Search"
        onClick={() => navigate('/search')}
        customStyle={{
          width: 'inherit',
          padding: '16px 32px',
          minWidth: 207,
          height: 48,
          fontSize: 18,
          fontWeight: 700,
        }}
      />
    </Container>
  );
};

export default OneTapNoMoreOffersScreen;
